export default {
  currentProdcut: null,
  imgPrefix:
    process.env.NODE_ENV === 'development'
      ? 'https://youxiang-server-1256354707.cos.ap-beijing.myqcloud.com/image/'
      : 'https://cos.ue-link.cn/image/',

  setUserInfo(value, projectCode = '') {
    if (value) localStorage.setItem(`userInfo${projectCode}`, JSON.stringify(value))
    else localStorage.setItem(`userInfo${projectCode}`, value)
  },
  getUserInfo(projectCode = '') {
    const userInfo = localStorage.getItem(`userInfo${projectCode}`)
    if (!userInfo) {
      return {
        token: '',
        customerID: '-1',
        username: ''
      }
    }
    return JSON.parse(userInfo)
  },
  getOpenid() {
    const openid = localStorage.getItem('openid')
    return openid
  },
  setOpenid(value) {
    localStorage.setItem('openid', value)
  },
  setPageStatus(value) {
    localStorage.setItem('pageStatus', value)
  },
  getPageStatus() {
    return localStorage.getItem('pageStatus')
  },
  setProjectCode(value) {
    localStorage.setItem('projectCode', value)
  },
  getProjectCode() {
    return localStorage.getItem('projectCode')
  },

  appId: 'wxbcc78cfdd68bb2e7',
  clientKey: '7a4dd7faa7f3ce1613581703c5e264e4',
  signature: '',
  isFromProductDetailPage: false
}
